import { render } from "./SoftProduct.vue?vue&type=template&id=1eb501d2&scoped=true"
import script from "./SoftProduct.vue?vue&type=script&lang=js"
export * from "./SoftProduct.vue?vue&type=script&lang=js"

import "./SoftProduct.vue?vue&type=style&index=0&id=1eb501d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb501d2"]])

export default __exports__